import { createBrowserRouter, Outlet, RouterProvider } from 'react-router-dom'
import Login from './pages/Login/Login'
import { AuthProvider } from './hooks/auth-redirector'
import { lazy, Suspense } from 'react'
import TermsDialog from './components/TermsDialog'
import AdminRoute from './components/AdminRoute'
import { VisitContextProvider } from './hooks/useVisit'
import { useGA4 } from './hooks/useGA4'

const Home = lazy(()=> import('./pages/Home/Home'))
const CastTalkRoom = lazy(()=> import('./pages/talk-room/CastTalkRoom'))
const UserTalkRoom = lazy(()=> import('./pages/talk-room/UserTalkRoom'))
const Setting = lazy(()=> import('./pages/Setting'))
const Admin = lazy(()=> import('./pages/admin/Admin'))
const Debug = lazy(()=> import('./pages/debug/Debug'))
const LP = lazy(()=> import('./pages/LP'))
const Tradelaw = lazy(()=> import('./pages/Tradelaw'))

const router = createBrowserRouter([
  {
    path: '/',
    Component () {
      useGA4()
      return <Suspense>
        <AuthProvider>
          <VisitContextProvider>
            <Outlet/>
            <TermsDialog/>
          </VisitContextProvider>
        </AuthProvider>
      </Suspense>
    },
    children: [
      {
        path: '/',
        element: <Home/>,
      },
      {
        path: '/setting',
        element: <Setting/>,
      },
      {
        path: '/admin',
        element: <AdminRoute><Admin/></AdminRoute>,
      },
      {
        path: '/cast_talk_room',
        element: <CastTalkRoom/>,
      },
      {
        path: '/user_talk_room',
        element: <UserTalkRoom/>,
      },
    ]
  },
  {
    path: '/login',
    element: <Login/>
  },
  {
    path: '/about',
    element: <LP/>
  },
  {
    path: '/tradelaw',
    element: <Tradelaw/>
  },
  {
    path: '/debug',
    element: <Suspense>
      <Debug/>
    </Suspense>,
  }
], {
  basename: import.meta.env.VITE_BASENAME
})

const Root: React.FC = ()=> <RouterProvider router={router}/>
export default Root
